import { render, staticRenderFns } from "./Proforma.vue?vue&type=template&id=bdf6fe98&"
import script from "./Proforma.vue?vue&type=script&lang=js&"
export * from "./Proforma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports